var _line;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20,13.54h.71a.72.72,0,0,1,.71.73h0v7.31a.72.72,0,0,1-.71.73H9.31a.72.72,0,0,1-.71-.73h0V14.27a.72.72,0,0,1,.71-.73H10v-.73a5,5,0,1,1,10,0ZM10,15v5.85H20V15Zm4.27,1.46h1.42v2.93H14.29Zm4.26-2.92v-.73a3.55,3.55,0,1,0-7.1,0v.73Z",
    fill: "#c4c7d2",
    style: {
      isolation: "isolate"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.45,
    y1: 24.26,
    x2: 24.12,
    y2: 6.58,
    fill: "none",
    stroke: "#c4c7d2",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.9c10a352.svg";
export { ForwardRef as ReactComponent };